export const CHANGE_DEVICE = 'vxcashBasChangeDevice';
export const PAGINATION_CHANGE_PAGE = 'vxcashBasPaginationChangePage';
export const CHANGE_COUNTRY = 'vxcashBasChangeCountry';
export const BOOMER_EVENT_STATE_CHANGE = 'vxcashBasStateChange';
export const SORT_LIST = 'vxcashBasSortList';
export const NEW_CHAT_URL = 'vxcashBasNewChatUrl';
export const CLEAR_CHAT_URL = 'vxcashBasClearChatUrl';
